import React from 'react';
import './TextWithImage.css';
// Supprimez l'import de imagePlaceholder si vous ne l'utilisez plus comme valeur par défaut,
// ou gardez-le pour une fallback si la prop 'image' n'est pas passée.
// import imagePlaceholder from '../../../assets/images/divers/perle/p1.jpg';
import { Link } from 'react-router-dom';

// Modifiez les props pour accepter 'image' et 'altText'
function TextWithImage({ title, text, imageSide, buttonLink, buttonText, image, altText }) {
  const containerClass = `text-image-container ${imageSide === 'right' ? 'image-right' : ''}`;

  return (
    <section className={containerClass}>
      <div className="text-column">
        <h2>{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: text }} />
        {buttonLink && buttonText && (
          <Link to={buttonLink} className="section-cta-button">{buttonText}</Link>
        )}
      </div>
      <div className="image-column">
        {/* Utilisez la prop 'image' si elle est fournie, sinon utilisez un placeholder */}
        <img src={image || /* Chemin vers votre image par défaut si aucune image n'est passée */ ''} alt={altText || title} />
      </div>
    </section>
  );
}

export default TextWithImage;